<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand">Services</a>
        <button class="navbar-toggler" type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation" @click="collapsed = !collapsed">
            <span class="navbar-toggler-icon"></span>
        </button>
        
        <div :class="[collapsed? 'collapse' : '', 'navbar-collapse']"
             id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li :class="['nav-item', active === '' ? 'active' : '']">
                    <a class="nav-link" @click="$emit('navigate', '')">All</a>
                </li>
                <li :class="['nav-item', active === service ? 'active' : '']"
                    v-for="(service, index) in services" :key="service">
                    <a class="nav-link"
                       @click="$emit('navigate', service)">
                        {{service}}
                    </a>
                </li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
                <input class="form-control mr-sm-2"
                       id="search"
                       type="search"
                       placeholder="Search"
                       aria-label="Search" :value="searchedValue"
                       @keyup.enter.prevent="$emit('update:searchedValue', searchedValue)"
                       @input="$emit('update:searchedValue', $event.target.value)">
            </form>
        </div>
    </nav>
</template>
<script>
export default {
    name: 'api-navbar',
    data () {
        return {
            collapsed: true
        };
    },
    props: {
        services: {
            type: Array
        },
        searchedValue: {
            type: String
        },
        active: {
            type: String
        },
        showSearch: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss" scoped>
    .nav-item {
        cursor: pointer;
        &.active {
            .nav-link {
                @include color('color', primary);
                font-weight: bold;
            }
        }
    }
</style>
